import React from "react";

//import logo from "../../assets/ddmlogo.png?url";
import logo from "../../assets/ddmlogo.webp?url";
import styles from "./Header.module.css"

import {Fragment, useEffect} from "react";
import {NavLink, useNavigate} from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';

import Notification from "../notification/Notification";
import Navigation from "./Navigation";
import ClearFix from "../common/ClearFix";

import * as routeConstants from "../../constants/routeConstants";

import { login, logout } from "../../store/auth/auth-actions";

const IS_DEV = process.env.REACT_APP_IS_DEV === 'true';

const Header = props => {
    const auth = useSelector((state) => state.auth);
    const notification = useSelector((state) => state.notification);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {onAuthSignal} = props;

    /*useEffect(() => {
  console.log("HEADER MOUNT");
  //alert("HEADER MOUNT");
  return () => {console.log("HEADER UNMOUNT"); alert("HEADER_UNMOUNT")}
}, []);*/

    const handleLoginClicked = () => {
        window.localStorage.clear();
        navigate(routeConstants.ROUTE_AUTH);
        dispatch(logout({tokenRefreshFlag: false}));
        if (onAuthSignal) onAuthSignal();
    }

    const handleClearToken = () => {
        window.localStorage.clear();
        navigate("/");
        dispatch(logout({tokenRefreshFlag: false}));
        if (onAuthSignal) onAuthSignal();
    }

    const handleExpireToken = () => {
        dispatch(login(auth.token, new Date(), true));
        if (onAuthSignal) onAuthSignal();
    }

    const HeaderLogo = React.memo(() => (
        <img src={logo} alt="Beautiful DDM logo" className={styles.headerImage} key="header-logo"/>
    ));

    return (
        <Fragment>
        <header className={styles.header}>
            <div className={styles.innerHeader} >
                <div className={styles.logo}>
                    <HeaderLogo />
                </div>
                <h2 className={styles.title}>Skill Matrix</h2>
                <div className={styles.headerRight}>
                    <Navigation />
                    <div className={styles.actions}>
                        {!auth.isLoggedIn && <button onClick={handleLoginClicked}>Login</button>}
                        {IS_DEV && auth.isLoggedIn && <button onClick={handleClearToken}>Clear token</button>}
                        {IS_DEV && auth.isLoggedIn && <button onClick={handleExpireToken}>Expire token</button>}
                    </div>
                </div>
            </div>
            <div styles={{display: "block"}}>
            {notification.notification && <Notification 
                status={notification.notification.status}
                message={notification.notification.message}
            />}
            </div>
        </header>
        </Fragment>
    )

        /*return (
        <Fragment>
        <header className={styles.header}>
            <div className={styles.innerHeader} >
                <div className={styles.logo}>
                <img src={logo} alt="DDM Consulting logo" onError={(e) => {console.error(`Loading logo failed ${e}`)}} onLoad={() => console.log("logo was loaded")}/>
                </div>
                <h2 className={styles.title}>Skill matrix</h2>
                <div className={styles.headerRight}>
                    <Navigation />
                    <div className={styles.actions}>
                        {/auth.isLoggedIn && <button onClick={logoutHandler}>Logout</button>   /*Hiding logout button because it'll also sign out the user in genesys and app will be intergrated, not stand-alone /}
                        {!auth.isLoggedIn && <NavLink to={routeConstants.ROUTE_AUTH}>Login</NavLink>}
                        {IS_DEV && auth.isLoggedIn && <button onClick={onExpireToken}>Expire token</button>}
                    </div>
                </div>
                <ClearFix />
            </div>
            {notification.notification && <Notification 
                status={notification.notification.status}
                message={notification.notification.message}
            />}
        </header>
        </Fragment>
    )*/
}

export default Header;